<template>
  <div>
    <a-modal
      title="备注"
      style="top: 20px;"
      :width="800"
      v-model="remarkible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
    >
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="添加备注">
          <a-input  v-decorator="['remark']"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>

</template>
<script>
  // 获取备注信息的接口
  import { getremarkList } from '@/api/finance/CustomerExpense'
  import pick from 'lodash.pick'
  import {getDictMap} from "../../../utils/dict";
  export default {
    name: 'enterGenerateModal',
    props: {
    },
    components: {
    },
    data () {
      return {

        // 控制备注弹框
        remarkible: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        removeible:false,
        mdl: {},
        remarkmdl:{},
        remarkList:{},
        form: this.$form.createForm(this)
      }
    },
    beforeCreate () {
    },
    methods: {
      add () {
        this.form.resetFields()
        this.edit({ brandId: 0 })
      },
      // 移除
      remove(remove){
        this.removeible = true

      },
      // 备注
      remark(record){
        this.remarkmdl = Object.assign(record)
        console.log(this.remarkmdl)
        this.remarkible = true
        // getremarkList(record.orderType,record.orderId)
        this.$nextTick(() => {
          // 设置一组输入控件的值
          this.form.setFieldsValue(pick(this.remarkmdl.remark, 'remark'))
        })
      },
    }
  }
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}
</style>